var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 763.74 763.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M733.73,233.23c-19.23-45.47-46.77-86.31-81.83-121.38-35.07-35.07-75.91-62.6-121.38-81.83C483.43,10.1,433.42,0,381.87,0s-101.56,10.1-148.64,30.01c-45.47,19.23-86.31,46.77-121.38,81.83-35.07,35.07-62.6,75.91-81.83,121.38C10.1,280.31,0,330.32,0,381.87s10.1,101.56,30.01,148.64c19.23,45.47,46.77,86.31,81.83,121.38,35.07,35.07,75.91,62.6,121.38,81.83,47.08,19.91,97.09,30.01,148.64,30.01s101.56-10.1,148.64-30.01c45.47-19.23,86.31-46.77,121.38-81.83,35.07-35.07,62.6-75.91,81.83-121.38,19.91-47.08,30.01-97.09,30.01-148.64s-10.1-101.56-30.01-148.64ZM607.97,607.97c-60.39,60.39-140.69,93.65-226.1,93.65s-165.71-33.26-226.1-93.65-93.65-140.69-93.65-226.1,33.26-165.71,93.65-226.1,140.69-93.65,226.1-93.65,165.71,33.26,226.1,93.65,93.65,140.69,93.65,226.1-33.26,165.71-93.65,226.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M347.4,425.93l-20.98-220.61v-13.79c0-14.39,8.39-22.78,22.78-22.78h65.35c14.99,0,22.78,8.39,22.78,22.78v13.79l-20.98,220.61c-1.8,14.39-10.19,21.58-23.98,21.58h-20.38c-14.39,0-22.78-7.19-24.58-21.58Z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 381.87,
    cy: 542.24,
    r: 52.76
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorAlert);
export default __webpack_public_path__ + "static/media/error-alert.b2bb93f7cd3a8f789787a79207180937.svg";
export { ForwardRef as ReactComponent };